module.exports = "<div class=\"ui-luckgift\">\n  <h1 class=\"ui-luckgift-h\">{{@title}}</h1>\n  <p class=\"ui-luckgift-c\" :html=\"@content\"></p>\n  <p class=\"ui-luckgift-g\"><a :attr=\"{href:@gourl, target: '_blank'}\">{{@gochanagetips}}</a></p>\n  <p class=\"ui-luckgift-t\" ms-if=\"@tipsContent\">{{@tipsContent}}</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// /usr/local/src/vipp-cli/web_modules/component/hdplatform/luckgift/content.html
// module id = 53
// module chunks = 0